import React from 'react';

export default function BottomLeftCorner() {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M23 1V0L22 0L0 0V1L22 1L22 23H23L23 1Z" fill="white" />
    </svg>
  );
}
